import React from "react";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import EmailIcon from '@mui/icons-material/Email';
import LinkIcon from '@mui/icons-material/Link';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import SignpostIcon from '@mui/icons-material/Signpost';
import LocationCityIcon from '@mui/icons-material/LocationCity';

export default function Footer(props) {
	const { t, i18n } = useTranslation("",{lng: props.language});
	
  	let navigate = useNavigate(); 
	
	const callUrl = (url) => {
		navigate(url);
	};
	
  	return (<Box style={{background: "#747474", borderTop: "2px solid #000", marginTop: "10px"}}>  	
				<Box sx={{ flexGrow: 1, display: {
							xs: 'block',
							sm: 'block',  
							md: 'none',  
							lg: 'none',  
							xl: 'none',  							
							} }}
				>
					<Grid container  className="footera" sx={{ paddingTop: "20px", paddingBottom: "20px"}}>
						<Grid item xs={12}>
							<Grid container spacing={2}>
								<Grid item xs={1} >
									        	
								</Grid>
								<Grid item xs={5} >
									<Box className="stdSubheadline">
										<img src="assets/logo-small.png" width="120px" />
									</Box>
									        	
								</Grid>
								<Grid item xs={5} >

												<ul class="empty" style={{marginTop: "0px"}}>
													<li><SignpostIcon sx={{fontSize: "1.5em"}}/>Westallee 1</li>
													<li><LocationCityIcon sx={{fontSize: "1.5em"}}/>56112 Lahnstein</li>
												</ul>
									        	
								</Grid>
								<Grid item xs={1} >
									        	
								</Grid>
							</Grid>

						</Grid>

						<Grid item xs={12}>
							<Grid container spacing={2}>
								<Grid item xs={2} >
									        	
								</Grid>
								<Grid item xs={8} >

									
									<ul class="empty" sx={{listStyleType: "none"}}>
										<li><EmailIcon sx={{fontSize: "1.5em"}}/><a style={{textDecoration: "none", color: "#fff"}} href="mailto: info@karst-immobilien.de">info@karst-immobilien.de</a></li>
										<li><PhoneInTalkIcon sx={{fontSize: "1.5em"}}/><a style={{textDecoration: "none", color: "#fff"}} href="tel: +49 2621 188 079">+49 2621 188 079</a></li>
									</ul>
									        	
								</Grid>
								<Grid item xs={2} >
									        	
								</Grid>
							</Grid>
						</Grid>
					</Grid>
<hr />
									<Grid container >
										<Grid item xs={12}>
											<Grid container spacing={2}>
												<Grid item xs={8}>
													<Box className="stdSubheadline" sx={{color: "#fff", fontSize: "16px"}}>
														Copyright 2026 Sabine Karst
													</Box>
													
												</Grid>
												<Grid item xs={4}>
													<Box className="stdSubheadline" sx={{float: "right"}}>
														<a style={{color: "#fff", fontSize: "16px"}} onClick={e => callUrl("/impressum")}>Impressum</a>
													</Box>
												</Grid>
											</Grid>
										</Grid>
									</Grid>
<br/>
<br/>
<br/>

				</Box>
				<Box sx={{ flexGrow: 1, display: {
							xs: 'none',
							sm: 'none',  
							md: 'block',  
							lg: 'block',  
							xl: 'block',  							
							} }}
				>
					<Grid container  className="footera" sx={{ paddingTop: "20px", paddingBottom: "20px"}}>
						<Grid item xs={12}>
							<Grid container spacing={2}>
								<Grid item xs={3} >
									        	
								</Grid>
								<Grid item className="footery" xs={6} >
									<Grid item xs={12}>
										<Grid container spacing={2}>
											<Grid item xs={3} >
												<Box className="stdSubheadline">
													<img src="assets/logo-small.png" width="120px" />
												</Box>
												<Box className="stdContent" sx={{float: "left"}}>
												</Box>  	
											</Grid>
											<Grid item xs={5}>
												<Box className="stdSubheadline" sx={{marginTop: "20px"}}>
													<b>{t("Adresse")}</b>
												</Box>
												<ul class="empty" sx={{listStyleType: "none"}}>
													<li><SignpostIcon sx={{fontSize: "1.5em"}}/>Westallee 1</li>
													<li><LocationCityIcon sx={{fontSize: "1.5em"}}/>56112 Lahnstein</li>
												</ul>
											</Grid>
											<Grid item xs={4}>
												<Box className="stdSubheadline" sx={{marginTop: "20px"}}>
													<b>{t("Kontakt")}</b>
												</Box>
												
												<ul class="empty" sx={{listStyleType: "none"}}>
													<li><EmailIcon sx={{fontSize: "1.5em"}}/><a style={{textDecoration: "none", color: "#fff"}} href="mailto: info@karst-immobilien.de">info@karst-immobilien.de</a></li>
													<li><PhoneInTalkIcon sx={{fontSize: "1.5em"}}/><a style={{textDecoration: "none", color: "#fff"}} href="tel: +49 2621 188 079">+49 2621 188 079</a></li>
												</ul>
													
											</Grid>
										</Grid>
									</Grid>
									<hr />
									<Grid container >
										<Grid item xs={12}>
											<Grid container spacing={2}>
												<Grid item xs={6}>
													<Box className="stdSubheadline" sx={{}}>
														Copyright 2026 Sabine Karst
													</Box>
													
												</Grid>
												<Grid item xs={6}>
													<Box className="stdSubheadline" sx={{float: "right"}}>
														<a style={{color: "#fff", fontSize: "16px"}} onClick={e => callUrl("/impressum")}>Impressum</a>
													</Box>
												</Grid>
											</Grid>
										</Grid>
									</Grid>
									
								</Grid>
								<Grid item xs={3} >
		
								</Grid>
										     	
							</Grid>
						</Grid>
					</Grid>	  	
				</Box>
			</Box>
	  )
}